import { Link } from 'react-router-dom';

import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function EntityLinkFormatter({ info, entity }) {
  getInfo(info)
  const { row } = getInfo(info)
  const name = row[`${entity}_name`]
  const id = row[`${entity}_id`]

  if (!id) {
    return '--'
  }

  return <div>
    <Link to={`/offer/${entity}s/${id}`} className="twy-text-base-accent hover:underline" >
      {`[#${id}] - ${name}`}
    </Link>
  </div>
}

export const entityLinkFormatter = (entity, id, name) => <DefaultTooltip content={`ID: ${id}`}>
  <Link to={`/offer/${entity}/${id}`} className="twy-text-base-accent hover:underline" >{name || '--'}</Link>
</DefaultTooltip>
